class CartItemGroupController {}

const cartItemGroupComponentDefinition = {
    bindings: {
        items: '<',
        groupName: '@',
        isInfo: '@',
        message: '@',
        actionLabel: '@',
        onAction: '&',
    },
    controller: CartItemGroupController,
    template: require('./cart-item-group.component.html').trim(),
};

module.exports = {
    CartItemGroupController,
    cartItemGroupComponentDefinition,
};



// WEBPACK FOOTER //
// ./src/shop/cart/cart-item-group.component.js